//export const BASE_URL = 'https://360-distinct-real-estate-backend.vercel.app';
export const BASE_URL = 'http://localhost:5003';